var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiModels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.52804V12.64C0 12.9174 0.096 13.152 0.288 13.344C0.490667 13.536 0.730667 13.632 1.008 13.632H15.008C15.2853 13.632 15.52 13.5307 15.712 13.328C15.904 13.136 16 12.9067 16 12.64V8.52804H0ZM15.008 12.64H1.008V9.63204H15.008V12.64ZM3.872 11.52H1.872V10.624H3.872V11.52ZM6.912 11.52H4.912V10.624H6.912V11.52ZM0 2.36804V6.48004C0 6.75738 0.096 6.99204 0.288 7.18404C0.490667 7.37604 0.730667 7.47204 1.008 7.47204H15.008C15.2853 7.47204 15.52 7.37604 15.712 7.18404C15.904 6.98138 16 6.74671 16 6.48004V2.36804H0ZM15.008 6.48004H1.008V3.47204H15.008V6.48004ZM3.872 5.36004H1.872V4.46404H3.872V5.36004ZM6.912 5.36004H4.912V4.46404H6.912V5.36004Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiModels);
export default __webpack_public_path__ + "static/media/aiModels.57971f42d937fe78d05fca95bf9b7122.svg";
export { ForwardRef as ReactComponent };